export var WidgetContentModuleType;
(function (WidgetContentModuleType) {
    WidgetContentModuleType[WidgetContentModuleType["CONTACT"] = 1] = "CONTACT";
    WidgetContentModuleType[WidgetContentModuleType["SEARCH_BAR"] = 2] = "SEARCH_BAR";
    WidgetContentModuleType[WidgetContentModuleType["FEATURED_ARTICLES"] = 3] = "FEATURED_ARTICLES";
    WidgetContentModuleType[WidgetContentModuleType["CATEGORY_LIST"] = 4] = "CATEGORY_LIST";
    WidgetContentModuleType[WidgetContentModuleType["CUSTOM_HTML"] = 11] = "CUSTOM_HTML";
    WidgetContentModuleType[WidgetContentModuleType["UPDATE_BOX"] = 21] = "UPDATE_BOX";
})(WidgetContentModuleType || (WidgetContentModuleType = {}));
export var WidgetContactType;
(function (WidgetContactType) {
    WidgetContactType[WidgetContactType["CONTACT_FORM"] = 1] = "CONTACT_FORM";
    WidgetContactType[WidgetContactType["CHAT"] = 2] = "CHAT";
    WidgetContactType[WidgetContactType["CALLBACK"] = 3] = "CALLBACK";
})(WidgetContactType || (WidgetContactType = {}));
export var WidgetLauncherSize;
(function (WidgetLauncherSize) {
    WidgetLauncherSize[WidgetLauncherSize["SMALL"] = 10] = "SMALL";
    WidgetLauncherSize[WidgetLauncherSize["LARGE"] = 20] = "LARGE";
})(WidgetLauncherSize || (WidgetLauncherSize = {}));
export var WidgetBackgroundPattern;
(function (WidgetBackgroundPattern) {
    WidgetBackgroundPattern["NONE"] = "none";
    WidgetBackgroundPattern["PARTY"] = "party";
    WidgetBackgroundPattern["COMO"] = "como";
    WidgetBackgroundPattern["ANGULAR"] = "angular";
    WidgetBackgroundPattern["STITCHES"] = "stitches";
})(WidgetBackgroundPattern || (WidgetBackgroundPattern = {}));
export var WidgetLauncherIcon;
(function (WidgetLauncherIcon) {
    WidgetLauncherIcon["CHAT"] = "chat";
    WidgetLauncherIcon["BOOK"] = "book";
    WidgetLauncherIcon["COMPASS"] = "compass";
    WidgetLauncherIcon["HELP"] = "help";
    WidgetLauncherIcon["PHONE"] = "phone";
})(WidgetLauncherIcon || (WidgetLauncherIcon = {}));
//# sourceMappingURL=domain.js.map